import { MENSAJES_SISTEMA_SHOW } from '../constants/mensajesSistema.constants';

export const LEVEL_WARNING = 'warning';
export const LEVEL_SUCCESS = 'success';
export const LEVEL_INFO = 'info';
export const LEVEL_DANGER = 'danger';

export const showMessage = ({
  title, message, httpError, level,
}) => ({
  type: MENSAJES_SISTEMA_SHOW,
  payload: {
    title, message, httpError, level,
  },
});

export const showInfo = ({ title, message, httpError }) => ({
  type: MENSAJES_SISTEMA_SHOW,
  payload: {
    title, message, level: LEVEL_INFO, httpError,
  },
});

export const showSuccess = ({ title, message, httpError }) => ({
  type: MENSAJES_SISTEMA_SHOW,
  payload: {
    title, message, level: LEVEL_SUCCESS, httpError,
  },
});

export const messageDanger = ({ title, message, httpError }) => ({
  type: MENSAJES_SISTEMA_SHOW,
  payload: {
    title, message, level: LEVEL_DANGER, httpError,
  },
});

export const toastDanger = ({ title, message, httpError }) => ({
  type: MENSAJES_SISTEMA_SHOW,
  payload: {
    title, message, level: LEVEL_DANGER, type: 'toast', httpError,
  },
});

export const showWarning = ({ title, message, httpError }) => showMessage({
  title, message, httpError, level: LEVEL_WARNING,
});

export const showDanger = ({ title, message, httpError }) => showMessage({
  title, message, httpError, level: LEVEL_DANGER,
});
